import React from "react";
import { ResponsiveContainer, AreaChart, Area } from "recharts";
import "./MetricTrendCard.css";

export default function MetricTrendCard({ title, subtitle, value, trendData, strokeColor, gradientId, icon, iconBgColor }) {
  return (
    <div className="card-premium d-flex flex-column justify-content-between">
      <div className="card-header-spark">
        <div className="d-flex align-items-center gap-3">
          <div className="spark-icon-wrapper" style={{ backgroundColor: iconBgColor }}>
            {icon}
          </div>
          <div>
            <h5 className="spark-title">{title}</h5>
            <p className="spark-subtitle">{subtitle}</p>
          </div>
        </div>
      </div>

      <div className="card-value-spark mt-3 px-3">
        <h2>{value}</h2>
      </div>

      <div className="sparkline-chart-wrapper">
        <ResponsiveContainer width="100%" height={60}>
          <AreaChart data={trendData} margin={{ top: 5, right: 0, left: 0, bottom: 0 }}>
            <defs>
              <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor={strokeColor} stopOpacity={0.4} />
                <stop offset="95%" stopColor={strokeColor} stopOpacity={0} />
              </linearGradient>
            </defs>
            <Area
              type="monotone"
              dataKey="value"
              stroke={strokeColor}
              strokeWidth={2.2}
              fillOpacity={1}
              fill={`url(#${gradientId})`}
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
